import { Box, Card, Skeleton, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function StatCard({ label, value, hint, icon, color = "#3D4F58", loading }) {
  return (
    <Card sx={{ p: 2.25, height: "100%" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1}>
        <Box sx={{ minWidth: 0 }}>
          <Typography color="text.secondary" sx={{ fontSize: 12.5, fontWeight: 600, mb: 0.5 }} noWrap>
            {label}
          </Typography>
          {loading ? (
            <Skeleton width={120} height={36} />
          ) : (
            <Typography
              sx={{
                fontSize: "1.45rem",
                fontWeight: 700,
                lineHeight: 1.25,
                fontVariantNumeric: "tabular-nums",
                wordBreak: "break-word",
              }}
            >
              {value}
            </Typography>
          )}
          {hint && (
            <Typography variant="caption" color="text.secondary">
              {hint}
            </Typography>
          )}
        </Box>
        {icon && (
          <Box
            sx={{
              flexShrink: 0,
              width: 38,
              height: 38,
              borderRadius: 2,
              display: "grid",
              placeItems: "center",
              color,
              bgcolor: alpha(color, 0.1),
            }}
          >
            {icon}
          </Box>
        )}
      </Stack>
    </Card>
  );
}
